<style>
.popover{
  max-width: 500px!important;
}
</style>
<script>
import {  mapGetters } from "vuex"; 
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Vue from 'vue';
import { notify } from '@/helpers/notify' 
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Arac from './arac_modal.vue'

export default {
    page: {
        title: "Araç Kontrol",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader,
        Arac
    },
    computed: {
        ...mapGetters('authfack',['userdata'])
    },
    data() {
        return {
            title: "Araç Kontrol",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "ARAÇ KONTROL",
                    active: true,
                },
            ], 
            searchParams: {},
            columns: [
                    { name: '', key: 'action', orderable: false, width:10  },
                    { name: 'Marka/Model', key: 'markamodel',  width: "15%" },
                    { name: 'Plaka', key: 'plaka',  width: "15%" },
                    { name: 'Zimmet Edilen', key: 'name',  width: "15%" },
                    { name: 'Seyrüsefer', key: 'seyrusefer',  width: "15%" },
                    { name: 'Sigorta Tarihi', key: 'sigorta',  width: "15%" },
                    { name: 'Muayene Tarihi', key: 'muayene',  width: "15%" },
            ],
            tableData: {
            detail: false,
            excel: true,
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            endpoint: '/vehicles',
            modelOpen:0,
            arac:{},
        };
    },

  methods: {
    async loadPage() {
        this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
        
        const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
        if (this.params.page === 1) {
            this.tableData.data = response.data.data;
        } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
        }
    
        this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false

        this.lastUpdated = new Date().toLocaleTimeString();
    },
    
  
    date(obj){
        return this.formatDate(obj, "DD.MM.YYYY")
    },

    sil(props){
      Vue.swal({
          title: "Ticket Kapanacak ?",
          showCancelButton: true,
          cancelButtonText: "Vazgeç",
          confirmButtonText: "Kapat"
      }).then((result) => {
          if (result.value) {
            this.$http.put('/tickets/' + props.id)
            .then(response => {
                if(response.data.code == 100){
                  this.loadPage()
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });
    },
    
    create(){
       this.modelOpen +=1
       this.arac = {} 
       this.$parent.$bvModal.show('vehicle_modal')
    },
    update(props){
       this.modelOpen +=1
       this.arac = props
       this.$parent.$bvModal.show('vehicle_modal')
    },
   }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

     <Arac 
      :modelOpen="modelOpen" 
      :data="arac"
      @loadItems="loadPage"
     />
      
    <div class="d-flex justify-content-end">
        <button class="btn btn-sm btn-success" @click="create">Yeni Oluştur</button>
    </div>
    <div class="row mt-2"> 
      <div class="col-12">
        <div class="card mb-0">
            <div class="card-body">
                <div class="table-responsive" style="min-height: 300px;">
                    <table class="table table-hover">
                        <thead class="table-head" >
                            <tr>
                                <th style="width:2%"></th>
                                <th :style="`width:${column.width}`" v-for="(column,i) in columns"  :key="i">{{ column.name }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in tableData.data" :key="rowIndex">
                                <th class="align-middle">{{ rowIndex+=1 }}</th>
                                <td v-for="(column, colIndex) in columns" :key="colIndex" class="align-middle">
                                    <template v-if="column.key == 'fullname'">{{  row.fname }} {{  row.lname }} </template>
                                    <template v-else-if="column.key == 'action'">
                                        <div style="height: 2rem;width: 2rem;border-radius: 50% !important;position: relative !important;">
                                            <span style="align-items: center;background:#dddddd;display: flex;justify-content: center;width:100%;height:100%;border-radius: 50% !important" > 
                                            <b-dropdown
                                                toggle-class="font-size-16 p-0"
                                                toggle-tag="a"
                                                variant="white"
                                                append-to-body
                                                >
                                                <template #button-content>
                                                <i class="mdi mdi-dots-horizontal"></i>
                                                </template>
                                                <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
                                            </b-dropdown>
                                            </span>
                                        </div>
                                    </template>
                                    <template v-else-if="column.key == 'markamodel'">{{  row.marka }} / {{  row.model }} </template>
                                    <template v-else-if="column.key == 'seyrusefer'"> {{ date(row.seyrusefer) }} </template>
                                    <template v-else-if="column.key == 'sigorta'"> {{ date(row.sigorta) }} </template>
                                    <template v-else-if="column.key == 'muayene'"> {{ date(row.muayene) }} </template>
                                    <template v-else>{{ row[column.key] }}</template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>